// Path identifies the object the State is attached to. Controlled targets,
// reference objects and Group links do not change Selected membership.
export function filterStateSets(sets, { scope = "all", kind = "all", paths = [] } = {}) {
    const selected = new Set(paths);
    return sets.filter(set => (kind === "all" || set.kind === kind)
        && (scope !== "selected" || selected.has(set.raw.Path ?? "")));
}
